import React from 'react';
import FormItemContainerControl from './FormItemContainerControl';
import FormItemTab from '../FormItemTab';
import FormResourceUtil from '../../utils/FormResourceUtil';
import CommandResolver from '../../utils/CommandResolver';
import FormItemUtil from '../../utils/FormItemUtil';
import UtilActions from '../../actions/UtilActions';
import CommandHelper from '../../remote/CommandHelper';
import ServiceHelper from '../../remote/ServiceHelper';

export default class FormItemTabControl extends FormItemContainerControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemTabControl";
	}

	tabPageChanged(tabPageXML)
	{
		let tabPageName = tabPageXML.name;
		let tabPageControl = FormItemUtil.getFormItemControl(
			FormItemUtil.getFormItemControlKey(this.menuItemId,this.formId,tabPageXML.id)
		);

		if(tabPageControl)
		{
			let gridControls = [];
			FormItemUtil.getDataGridUnderFormItem(tabPageControl,gridControls);
			for(let i = 0;i<gridControls.length;i++)
			{
				let gridControl = gridControls[i];
				UtilActions.tabpageUserChanged({
					moduleInstanceId:this.module.instanceUUId,
					gridId:gridControl.xml.id
				});
			}
		}
		
		if(this.module && this.module.classAlias == "FormModule")
			this.module.focusController.initFocus(false,tabPageControl);
		let mi = FormResourceUtil.getCommandArgMethodInfo("tabPageChanged_"+tabPageName,this.menuItemId,this.formId);
	    if(mi)
	    {
	      let formModule = this.module;
	      if(mi.prefetch==true)
	      {
	        CommandResolver.resolve(mi.commandResult.tasks, formModule, this.group);
	      }
	      else
	      {
	        var arg = CommandResolver.getSendCmd(formModule, this.groupAlias, mi);
	        var command = CommandHelper.createFormInstance(formModule.formName,"doTabPageChanged","CommandResult");
	        command.appendArg(tabPageName, "String")
	          .appendArg(arg,"CommandArg");
	        
	        ServiceHelper.addTokenWithCommand({command:command,resultFunction:this.doTabPageChangedRemoteResultHandler.bind(this),sync:false});
	      }
	    }
	}

	doTabPageChangedRemoteResultHandler(data)
	{
		CommandResolver.resolve(data.result.tasks, this.module, this.group);
	}

	setInitSelectIndex(index)
	{
		this.initSelectIndex = index;
	}

	getStyle()
	{
		//对于Tab本身没有任何布局 所以只关心父级布局情况
		let parentLayout = this.parentXML.Properties.Layout.Value;
		//本身固定布局为flex 纵向 因为要布局下面的标签选项卡与内容区域 内容区域填充剩余空间
		let style = {
		  	display:'flex',
		  	flex:'none',
		  	flexDirection:'column',
			paddingTop:'2px'
	    };
		
		//如果设置了Width或者Height属性 则按照属性设置 否则为百分百 与Flex版框架保持一致	   
		//但是存在其余控件包含tab而设置成百分百的情况 此情况在Flex版框架中也没有考虑 但是在实际
		//使用过程中并未提出此问题 所以暂不考虑
	    
	    if(parentLayout == "horizontal")
	    {
	    	//let json = JSON.stringify(this.props.xml.Properties.Width.Value);
	    	//alert(json);
	    	let _width = this.xml.Properties.Width.Value;
	    	if(_width == undefined)
	    		_width = "";
			let flexGrow = 0;
			let fixedWidth = false;
			if(_width == "")// && !window.isPopUp && !window.isLookup)
			{
				flexGrow = 100;
				//let _containsMaxControl = this.containsMaxControlForWidth(this.xml);
				//if(_containsMaxControl)flexGrow = 100;
			}
			else
			{
				let iex = _width.indexOf("%");
				if(iex!=-1)
				{
					flexGrow = _width.substring(0,iex);
					//20210413 支持直接填写百分比 不使用flexGrow代替
					style.width = _width;
				}
				
				if(iex==-1&&_width != "")
				{
					flexGrow = _width+"px";
					fixedWidth = true;
				}	
			}
			
			if(!fixedWidth)style["flexGrow"] = flexGrow; 

			let _height = this.xml.Properties.Height.Value;
			if(_height == undefined)
				_height = "";

			if(_height == "" && !window.isPopUp && !window.isLookup)
			{
				if(this.module.hasUpDownDataGrid)
				{
					let _containsMaxControl = this.containsMaxControlForHeight(this.xml);
				 	if(_containsMaxControl)_height = "100%";	
				}
				else
				{
					_height = "100%";
				}
				 
			}
			if(_height == "100%")
				style["alignSelf"] = "stretch";
			else if(_height.indexOf("%") != -1)
				style["height"] = _height;
			else if(_height != "")
				style["height"] = _height+"px";
	    }
	    else //vertical 暂不考虑absolute
	    {
	    	let _height = this.xml.Properties.Height.Value;
	    	if(_height==undefined)
	    		_height = "";
			let flexGrow = 0;
			let fixedHeight = false;

			flexGrow = 0;
			if(_height == "" && !window.isPopUp && !window.isLookup)
			{
				if(this.module.hasUpDownDataGrid)
				{
					let _containsMaxControl = this.containsMaxControlForHeight(this.xml);
					if(_containsMaxControl)flexGrow = 100;	
				}
				else
				{
					flexGrow = 100;
				}
				
			}
			else
			{
				let iex = _height.indexOf("%");
				if(iex!=-1)
				{
					flexGrow = _height.substring(0,iex);
					style.height = _height;
				}
				if(iex==-1&&_height != "")
				{
					flexGrow = _height+"px";
					fixedHeight = true;
				}	
			}
			
			if(!fixedHeight)style["flexGrow"] = flexGrow;
			else style["height"] = flexGrow;  

			let _width = this.xml.Properties.Width.Value;
			if(_width == undefined)
				_width = "";
			if(_width == "" && !window.isPopUp && !window.isLookup)
			{
				_width = "100%";
				 //let _containsMaxControl = this.containsMaxControlForWidth(this.xml);
				 //if(_containsMaxControl)_width = "100%";
			}
			if(_width == "100%")
				style["alignSelf"] = "stretch";
			else if(_width.indexOf("%") != -1)
				style["width"] = _width;
			else if(_width != "")
				style["width"] = _width+"px";
			else if(window.isPopUp)
				style["alignSelf"] = "stretch";
	    }
		return style;
	}
	
	getComponentInstance(parent,forLookup)
	{
		let layout = parent.Properties.Layout.Value;
		let currentIndex = this.initSelectIndex?this.initSelectIndex:0;
		let currentIndexBak = currentIndex;
		let unVisibleIndexes = [];
		let currentVisible;
		for(let i = 0;i<this.childrenControl.length;i++)
		{
			let currentPageControl = this.childrenControl[i];
			let visible = currentPageControl.getProperty_Visible_Final();
			if(!visible)
				unVisibleIndexes.push(i);
			if(i == currentIndex)
				currentVisible = visible;
			
		}
		while(!currentVisible)
		{
			if((currentIndex+1)<this.childrenControl.length)
				currentIndex++;
			else
				currentIndex = 0;
			if(currentIndex == currentIndexBak)
			{
				currentIndex = -1;break;
			}
			let currentPageControl = this.childrenControl[currentIndex];
			currentVisible = currentPageControl.getProperty_Visible_Final();
		}
		let commonProps = this.getCommonProps();
		this.component = <FormItemTab key={this.xml.id} xml={this.xml} moduleInstanceId={this.module.instanceUUId} 
                              parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias} customStyle={this.getStyle()}
                              formId={this.formId} menuItemId={this.menuItemId} initSelectIndex={currentIndex} unVisiblePages={unVisibleIndexes}
                              contextMenuData={this.contextMenuData} control={this} {...commonProps}/>;
		return this.component;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemTabControl.js